'use strict';

import VZTcBaseCard from './VZTcBaseCard';

/**
 * @class VZTcPorting
 * @extends VZTcBaseCard
 * @description Handles the Teams Calling porting card with quantity selection functionality
 */
export default class VZTcPorting extends VZTcBaseCard {
    constructor() {
        super();
    }

    /**
     * @function initializeQuantitySelector
     * @description Sets up the quantity selector event listeners
     */
    initializeQuantitySelector() {
        this.quantitySelector = this.querySelector('.js-tc-porting-quantity-input');

        if (this.quantitySelector) {
            this.boundQuantityChange = this.onQuantityChange.bind(this);
            this.quantitySelector.addEventListener('fieldUpdated', this.boundQuantityChange);
        }
    }

    /**
     * @function connectedCallback
     * @description Sets up the card when element is added to the DOM
     */
    connectedCallback() {
        super.initializeCard();
        this.initializeQuantitySelector();

        // Listen for content updates to reattach event listeners
        this.boundContentUpdated = this.onContentUpdated.bind(this);
        this.productCard.addEventListener('teamscalling:contentupdated', this.boundContentUpdated);
    }

    /**
     * @function disconnectedCallback
     * @description Cleanup when element is removed from the DOM
     */
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListeners();
    }

    /**
     * @function removeEventListeners
     * @description Removes all event listeners
     */
    removeEventListeners() {
        if (this.quantitySelector) {
            this.quantitySelector.removeEventListener('fieldUpdated', this.boundQuantityChange);
        }

        if (this.productCard) {
            this.productCard.removeEventListener('teamscalling:contentupdated', this.boundContentUpdated);
        }
    }

    /**
     * @function onContentUpdated
     * @description Reinitializes card after content update
     */
    onContentUpdated() {
        this.initializeQuantitySelector();
    }

    /**
     * @function onQuantityChange
     * @description Handles quantity changes
     * @param {CustomEvent} evt - The fieldUpdated event
     */
    onQuantityChange(evt) {
        const quantity = parseInt(evt.target.value, 10);

        // Update configuration and content
        const addToCartValues = document.querySelector('.js-add-to-cart-values');
        if (addToCartValues) {
            addToCartValues.dataset.porting = quantity;
        }

        this.updateConfig('portingQty', this.questionId, quantity.toString(), { subQuestionType: this.subQuestionType });
    }
}

if (!window.customElements.get('vz-tc-porting')) {
    window.customElements.define('vz-tc-porting', VZTcPorting);
}
